@let feed = checkInFeature.selectors.feed.asSignal();
@let isLoading = checkInFeature.selectors.feedIsLoading.asSignal();

@if (feed.length) {
  <div class="atn-summit-check-ins-feed">
    @for (entry of feed; track entry.submittedOn.valueOf()) {
      <atn-summit-check-ins-entry [entry]="entry" />
    }
  </div>
} @else if (isLoading) {
  <atn-ds-loader />
} @else {
  <div class="atn-summit-check-ins-feed__empty-state-container">
    <div class="atn-summit-check-ins-feed__empty-state-content">
      <atn-ds-empty-state
        type="no-data"
        title="No Matching Check-Ins"
        description="There are no check-ins that match the current filters. You can try resetting the filters with the button below."
        action="Reset"
        (action)="
          checkInFeature.actions.loadFeed
            .from('CheckInsPage.EmptyState.ResetButton.Clicked')
            .dispatch(undefined)
        "
      />
    </div>
  </div>
  <!-- TODO: the above action should probably be something like `checkInFeature.actions.resetFeed` -->
}
